<template>
  <div class="right">
    <div class="menu">
      <ul>
        <li><a href="/katalog" title="Katalog.">Katalog</a></li>
        <li>
          <a href="/kosik" title="Košík.">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="85" height="85" viewBox="0 0 85 85">
              <defs>
                <clipPath id="a">
                  <rect width="38.38" height="35" fill="#fff" stroke="#fff" stroke-width="1"/>
                </clipPath>
                <clipPath id="b">
                  <rect width="38.381" height="35" fill="#fff" stroke="#fff" stroke-width="1"/>
                </clipPath>
                <clipPath id="c">
                  <rect width="36.727" height="33.346" fill="#fff" stroke="#fff"
                        stroke-width="1"/>
                </clipPath>
              </defs>
              <g transform="translate(-1605 -141)">
                <circle cx="42.5" cy="42.5" r="42.5" transform="translate(1605 141)"/>
                <g transform="translate(1628 166)">
                  <g clip-path="url(#a)">
                    <g transform="translate(0 0)">
                      <g clip-path="url(#b)">
                        <g transform="translate(0.827 0.827)" opacity="0">
                          <g clip-path="url(#c)">
                            <path d="M19.943,28.231h4.642a4.686,4.686,0,1,0,9.311,0h3.331V5.843H12.468a.668.668,0,1,0,0,1.336H35.892V26.894H32.017a3.349,3.349,0,1,1-5.553,0H17.818a3.349,3.349,0,1,1-4.936,0H7.067V.5h-5.9A.677.677,0,0,0,.5,1.17a.676.676,0,0,0,.666.668H5.73V28.231h5.026a4.686,4.686,0,1,0,9.187,0"
                                  transform="translate(-0.5 -0.5)" fill="#fff"
                                  stroke="#fff" stroke-width="1"/>
                          </g>
                        </g>
                        <path d="M19.943,28.231h4.642a4.686,4.686,0,1,0,9.311,0h3.331V5.843H12.468a.668.668,0,1,0,0,1.336H35.892V26.894H32.017a3.349,3.349,0,1,1-5.553,0H17.818a3.349,3.349,0,1,1-4.936,0H7.067V.5h-5.9A.677.677,0,0,0,.5,1.17a.676.676,0,0,0,.666.668H5.73V28.231h5.026a4.686,4.686,0,1,0,9.187,0Z"
                              transform="translate(0.327 0.327)" fill="#fff" stroke="#fff"
                              stroke-width="1"/>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "theMenu",
  components: {}
};
</script>
